import { route } from 'preact-router';

// Wraps preact-router's route() so that supporting browsers use the native
// View Transitions API for the navigation. Falls back to a direct route() call
// when the API is unavailable or the user has requested reduced motion.
//
// preact-router exposes no navigation lifecycle hook of its own; every call
// site in the app should import this helper instead of `route` directly.
export function navigate(path: string, replace = false): void {
  if (!supportsViewTransitions() || prefersReducedMotion()) {
    route(path, replace);
    return;
  }
  (document as unknown as { startViewTransition: (cb: () => void) => unknown })
    .startViewTransition(() => {
      route(path, replace);
    });
}

function supportsViewTransitions(): boolean {
  return typeof document !== 'undefined' && 'startViewTransition' in document;
}

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
